import {
  AssigneeHolder,
  AssigneeImage,
} from 'components/common/UsersList/UsersList.styles'
import styled, { css } from 'styled-components'
import { LAPTOP_BREAKPOINT } from 'helpers/responsive'
import { ListItem, Menu, Icon } from '@material-ui/core'
import { Flex, truncateStyles } from 'components/common/styles'
import {
  MAIN_BACKGROUND,
  PRIMARY_TEXT,
  PURPLE,
  SILVER_LIGHT,
  WHITE,
  PURPLE_RGB,
  GRAY2,
  SECONDARY_TEXT,
  PRIMARY_TEXT_RGB,
  GRAY5,
  GRAY6,
  GRAY7,
  GRAY_RGB,
  RED_RGB,
  LIGHT_RED,
  GREEN,
  YELLOW,
  BLUE,
  BORDER_GRAY,
} from 'constants/colors'
import { Colors } from './ManagementUI.types'

export const StyledManagementUICol = styled(Flex)`
  position: relative;
  z-index: 1;
  text-align: center;
`

export const StyledUnitsCol = styled(StyledManagementUICol)`
  width: 155px;
  min-width: 155px;
  padding-left: 10px;

  > div {
    ${truncateStyles}
  }
`

export const ManagementUITitleContainer = styled(Flex)`
  border-bottom: 1px solid ${SILVER_LIGHT};
  background-color: ${WHITE};
`

export const ManagementUITitle = styled.h2<{
  hasOpacity?: boolean
}>`
  font-size: 18px;
  font-weight: 600;
  color: ${PRIMARY_TEXT};
  line-height: normal;
  padding: 19px 10px 19px 16px;
  margin: 0;
  text-transform: capitalize;

  ${({ hasOpacity }) =>
    hasOpacity &&
    css`
      color: rgba(${PRIMARY_TEXT_RGB}, 0.5);
    `}
`

export const ManagementUIAppWrapper = styled.div<{
  isNewHeader?: boolean
}>`
  ${({ isNewHeader }) =>
    isNewHeader &&
    css`
      .management-ui-sidebar {
        ${ManagementUITitleContainer} {
          @media (max-width: ${LAPTOP_BREAKPOINT}px) {
            padding: 20px 16px 19px 52px;
          }
        }
      }

      .management-ui-content {
        ${ManagementUITitleContainer} {
          padding-right: 231px;

          @media (max-width: ${LAPTOP_BREAKPOINT}px) {
            padding-right: 52px;
          }
        }
      }
    `}
`

export const FilterBarWrapper = styled(Flex)`
  padding: 0 16px 16px;
  background: ${WHITE};
  border-bottom: 1px solid ${BORDER_GRAY};

  > div {
    margin-top: 16px;
    margin-right: 10px;

    &:last-child {
      margin-left: auto;
    }
  }

  .MuiInputBase-root {
    font-size: 16px;
  }

  .MuiFormControl-root .MuiSelect-select.MuiSelect-selectMenu {
    max-width: 250px;
    font-size: 16px;
    font-weight: 400;
    line-height: 18px;
  }
`

export const FilterButton = styled.div<{
  isMenuOpen?: boolean
  isSingleFilterSelected: boolean
}>`
  > button {
    height: 36px;
    border-radius: 8px;
    background-color: ${({ isMenuOpen }) =>
      isMenuOpen ? css`rgba(${PURPLE_RGB}, 0.15)` : MAIN_BACKGROUND};
    text-transform: capitalize;
    color: ${({ isMenuOpen }) => (isMenuOpen ? PURPLE : PRIMARY_TEXT)};
    font-weight: 400;
    font-size: 16px;
    padding: 8px 14px;
    white-space: nowrap;
    min-width: 100px;
    justify-content: space-between;

    ${({ isSingleFilterSelected }) =>
      isSingleFilterSelected &&
      css`
        .MuiButton-label {
          > div {
            span {
              margin-right: 15px;
            }
          }
        }
      `}

    svg {
      stroke: ${({ isMenuOpen }) => (isMenuOpen ? PURPLE : PRIMARY_TEXT)};

      &:nth-child(1) {
        margin-right: 10px;
      }

      &:nth-child(2) {
        margin-left: 10px;
        transform: ${({ isMenuOpen }) => isMenuOpen && css`rotate(180deg)`}
      }
  }
`

export const Container = styled(Flex)`
  button {
    height: 100%;
  }
`

export const StyledTabs = styled.div`
  background-color: ${WHITE};

  .MuiTabs-root {
    min-height: 36px;
    max-height: 36px;
    overflow: unset;

    .MuiTabs-indicator {
      background: transparent;
    }
  }

  .MuiTab-root {
    border: 1px solid ${GRAY2};
    border-radius: 8px 0 0 8px;
    font-size: 16px;
    line-height: 100%;
    min-height: 36px;
    min-width: auto;
    text-transform: none;
    color: ${SECONDARY_TEXT};
    font-weight: 400;

    &:last-child {
      border-radius: 0 8px 8px 0;
      margin-left: -1px;
    }

    &.Mui-selected {
      background-color: ${MAIN_BACKGROUND};
      color: ${PRIMARY_TEXT};
    }
  }
`

export const SidebarTabs = styled(StyledTabs)`
  .MuiTabs-root {
    max-height: 100%;
    padding: 16px;
    margin: 0;

    .MuiTab-root {
      border: none;
      border-radius: 8px;
      font-size: 16px;
      line-height: 19px;
      min-height: 40px;
      text-transform: none;
      color: ${SECONDARY_TEXT};
      font-weight: 400;
      margin-bottom: 4px;
      padding: 10px 12px;

      svg {
        color: ${SECONDARY_TEXT};
        width: 18px;
        height: 18px;
      }

      &.Mui-selected,
      &:hover {
        background-color: ${MAIN_BACKGROUND};
        color: ${PRIMARY_TEXT};

        svg {
          color: ${PRIMARY_TEXT};
        }
      }

      .MuiTab-wrapper {
        flex-direction: row;
        justify-content: start;
      }
    }

    .MuiTab-labelIcon .MuiTab-wrapper svg {
      margin: 0 10px 0 0;
    }
  }
`

export const ResetFiltersButton = styled.span<{ isMenuOpen?: boolean }>`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  height: 10px;
  width: 10px;
  cursor: pointer;

  &:before,
  &:after {
    position: absolute;
    content: '';
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    background: ${({ isMenuOpen }) => (isMenuOpen ? PURPLE : PRIMARY_TEXT)};
  }

  &:before {
    transform: translateY(-50%) rotateZ(45deg);
  }

  &:after {
    transform: translateY(-50%) rotateZ(-45deg);
  }
`

export const JobsHeaderColumn = styled(Flex)`
  position: relative;
  z-index: 1;
  text-align: center;
  min-width: 155px;
  width: 155px;
  padding-left: 10px;
  text-transform: capitalize;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: ${PRIMARY_TEXT};
`

export const JobsHeaderColumnJobName = styled.span`
  padding: 10px 0 10px 36px;
`

export const MenuItem = styled(ListItem).attrs(() => ({
  button: false,
}))<{ $isActive?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  min-width: 100px;
  width: 100%;
  padding-right: 40px;
  text-transform: capitalize;
  cursor: pointer;
  transition: 0.3s;
  ${({ $isActive }) =>
    $isActive &&
    css`
      background: rgba(${PURPLE_RGB}, 0.1);
    `}

  &:hover {
    background: rgba(${PURPLE_RGB}, 0.1);
  }

  svg {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
  }
`

export const SingleJob = styled.div`
  position: relative;
  padding: 8px;
  background: ${WHITE};
  box-shadow: 0 5px 10px rgba(200, 200, 200, 0.25);
  margin-bottom: 1px;
  font-size: 16px;
  line-height: 22px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const IconHolder = styled(Flex)`
  position: relative;
  margin-right: 11px;
  margin-left: 10px;
  cursor: pointer;

  &:before {
    position: absolute;
    content: '';
    width: 18px;
    height: 18px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transition: 0.3s;
    border-radius: 4px;
  }

  &:hover {
    &:before {
      background: rgba(${GRAY_RGB}, 0.1);
    }
  }
`

export const PreviewItem = styled.div`
  font-size: 14px;
  margin-right: 8px;
  color: ${GRAY7};
`

export const SingleJobTask = styled(SingleJob)`
  cursor: default;

  &:before {
    position: absolute;
    content: '';
    left: -20px;
    width: 12px;
    height: 2px;
    top: 50%;
    transform: translateY(-50%);
    background: ${GRAY6};
  }
`

export const ManagementUICol = styled(Flex).attrs(() => ({
  align: 'center',
  justify: 'left',
}))`
  position: relative;
  z-index: 1;
  text-align: center;
  padding-left: 10px;
  min-width: 155px;
  width: 155px;
`

export const NameCol = styled(ManagementUICol)`
  width: 100%;
  min-width: 310px;
  text-align: left;
  justify-content: flex-start;
  padding-left: 0;
`

export const NameColTask = styled(NameCol)`
  cursor: text;
`

export const ConfigureCol = styled(ManagementUICol)`
  min-width: 24px;
  width: 24px;
  padding-left: 0;

  svg {
    cursor: pointer;
  }
`

export const StatusIndicatorCol = styled(ManagementUICol)`
  .dl-status-icon {
    margin: 0;
  }
`

export const OtherCol = styled(ManagementUICol)`
  min-height: 30px;
  height: 30px;

  ${AssigneeHolder} {
    width: 28px;
    min-width: 28px;
    height: 28px;
  }

  ${AssigneeImage} {
    width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: -10px;

    &:first-child {
      margin-left: 0;
    }
  }
`

export const OverdueCol = styled(ManagementUICol)`
  min-width: 100px;
  width: 100px;
`

export const RecurrenceCol = styled(ManagementUICol)`
  min-width: 200px;
`

export const MediaCol = styled(ManagementUICol)`
  svg {
    margin-left: 4px;
    stroke: ${GRAY5};
  }
`

export const CreatedByCol = styled(ManagementUICol)`
  min-height: 30px;
  height: 30px;

  ${AssigneeHolder} {
    width: 28px;
    min-width: 28px;
    height: 28px;
  }

  ${AssigneeImage} {
    width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: -10px;

    &:first-child {
      margin-left: 0;
    }
  }
`

export const TasksCompletedCol = styled(ManagementUICol)`
  min-width: 150px;
  width: 150px;
`

export const Label = styled.span`
  color: ${GRAY5};
  max-width: 290px;

  ${truncateStyles}
`

export const MoreOptionsIcon = styled(Icon)`
  transition: 0.3s;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: ${GRAY2};
  }
`

export const MUIMenu = styled(Menu)`
  font-size: 16px;
  line-height: 22px;

  .MuiMenu-paper {
    transform: translateY(47px) !important;
  }

  &.no-transform {
    .MuiMenu-paper {
      transform: translateY(0px) !important;
    }
  }
`

export const ContextMenuItem = styled(Flex).attrs(() => ({
  align: 'center',
}))`
  font-size: 16px;
  line-height: 22px;
  color: ${LIGHT_RED};
  padding: 11px 16px 11px 32px;
  min-width: 300px;

  &:hover {
    background: rgba(${RED_RGB}, 0.1);
  }

  svg,
  .material-icons {
    position: relative;
    top: initial;
    right: initial;
    transform: none;
    margin-right: 8px;
    font-size: 18px;
  }
`

export const ContextMenuItemSecondary = styled(ContextMenuItem)`
  color: ${GRAY5};
  border-bottom: 1px solid ${SILVER_LIGHT};

  &:hover {
    background: rgba(${GRAY_RGB}, 0.1);
  }

  &:last-child {
    border-bottom: none;
  }
`

export const PaginationContainer = styled.div`
  margin-top: auto;
  margin-bottom: 0;

  .MuiTablePagination-select {
    line-height: 20px;
  }

  .MuiTablePagination-root {
    color: ${PRIMARY_TEXT};
  }

  > div {
    background-color: ${WHITE};
  }
`

export const JobListWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;

  > div {
    width: fit-content;
    min-width: 100%;
  }
`

export const StatusIcon = styled.div<{ color?: Colors }>`
  width: 14px;
  height: 14px;
  border-radius: 14px;
  ${({ color }) =>
    color === Colors.blue &&
    css`
      background: ${BLUE};
    `};
  ${({ color }) =>
    color === Colors.yellow &&
    css`
      background: ${YELLOW};
    `};
  ${({ color }) =>
    color === Colors.green &&
    css`
      background: ${GREEN};
    `};
`
